import script from "./CustomPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomPopover.vue?vue&type=script&setup=true&lang=js"

import "./CustomPopover.vue?vue&type=style&index=0&id=42cb50b9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42cb50b9"]])

export default __exports__